import React, { Fragment, useState, useEffect } from "react";
import Classes from "../../createOrders/css/Modal.module.css";
import axiosInstance from '../../../../utility/axios-instance';
import { TextField, Autocomplete } from '@mui/material';
import Spinner from '../../../../components/spinner';

const ShippingPopUp = (props) => {
    const [states,setStates] = useState([]);
    const [loading,setLoading] = useState(false);

    const {
        shippingModal,
        hideShippingPop,
        showCustomerProfile,
        addressArray,
        setAddressArray,
        setAddress,
        pincode,
        setPincode,
        number,
        setNumber,
        actionType = "Edit",
    } = props;
    const [selectedState, setSelectedState] = useState('');

    const handlePincodeChange = async (event) => {
        const limit = 6;
        const enteredPincode = event.target.value.slice(0, limit)
        setPincode(enteredPincode);
        try {
            const response = await fetch(`https://api.postalpincode.in/pincode/${enteredPincode}`);
            const data = await response.json();

            if (data[0]?.Status === 'Success') {
                const extractedState = data[0]?.PostOffice[0]?.State;
                setSelectedState(extractedState);
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    const handleSubmit = (event) => {
        setLoading(true);
        event.preventDefault();
        hideShippingPop();
        const data = {
            address1: event.target.address1.value,
            address2: event.target.address2.value,
            city: event.target.city.value,
            province: event.target.state.value,
            zip: event.target.pincode.value,
            country: event.target.country.value,
            firstName: event.target.first.value,
            lastName: event.target.last.value ? event.target.last.value : undefined,
            phone: `+91${event.target.phone.value}`,
            addressType: "shipping",
        }


        axiosInstance
            .post(`/user/admin/${showCustomerProfile.id}/address`, { ...data })
            .then((res) => {
                setLoading(false);
                setNumber('');
                setPincode('');
                setSelectedState('');
                if (addressArray.length === 0) {
                    setAddress([res.data.data]);
                    setAddressArray([res.data.data]);
                } else {
                    setAddressArray([...addressArray, res.data.data]);
                }
            });
    }

    const handleMinLengthPinCode = (event) => {
        if (event.target.value) {
            const pincode = /^\d{6}$/;
            if (event.target.value.match(pincode)) {
                document.getElementById('pinErrMsg').style.display = 'none';
                document.getElementById('addAddress').disabled = false;
            } else {
                document.getElementById('addCustomer').disabled = true;
                document.getElementById('addAddress').style.display = 'block';
            }
        } else {
            document.getElementById('pinErrMsg').style.display = 'none';
            document.getElementById('addAddress').disabled = false;
        }
    }



    const handleMinLengthNumber = (event) => {
        if (event.target.value) {
            const pincode = /^\d{10}$/;
            if (event.target.value.match(pincode)) {
                document.getElementById('phoneErrMsg').style.display = 'none';
                document.getElementById('addAddress').disabled = false;
            } else {
                document.getElementById('addAddress').disabled = true;
                document.getElementById('phoneErrMsg').style.display = 'block';
            }
        } else {
            document.getElementById('phoneErrMsg').style.display = 'none';
            document.getElementById('addAddress').disabled = false;
        }
    }


    const handleNumberChange = (event) => {
        const limit = 10;
        setNumber(event.target.value.slice(0, limit));
    };

    useEffect(() => {
        axiosInstance
            .get('/pincode/getAllStates')
            .then((response) => {
                setStates(response.data.data);
            })
    },[])


    return (
        <Fragment>
            {shippingModal && (
                <div
                    className={Classes.modal}
                    style={{ bottom: '10%' }}
                >
                    <div className={Classes.BoxContent}>
                        <p>{ actionType === "Add" ? "Add" : "Edit" } Shipping Address</p>
                    </div>

                    <form method="post" onSubmit={handleSubmit} id='form'>
                        <div className={Classes.ShippingAddressPopup} style={{padding:20}}>
                            <div>
                                <TextField 
                                    id='country'
                                    name='country'
                                    label='Country / Origin'
                                    value='India'
                                    autoComplete='off'
                                    sx={{ width: '100%',"& label": {top:"0%",fontSize:14},"& .MuiOutlinedInput-input":{padding:'6px 10px'}}}
                                    disabled={true}
                                />
                            </div>

                            <div style={{ display:'flex',marginTop:10,justifyContent:'space-between' }}>
                                <div style={{ width: '48%'}}>
                                    <TextField 
                                        required={true}
                                        id='first'
                                        name='first'
                                        label='First Name'
                                        autoComplete='off'
                                        placeholder='Enter Your First Name'
                                        sx={{ width: '100%'}}
                                    />
                                </div>

                                <div style={{ width: '48%' }}>
                                    <TextField 
                                        id='last'
                                        name='last'
                                        label='Last Name'
                                        autoComplete='off'
                                        placeholder='Enter Your Last Name'
                                        sx={{ width: '100%'}}
                                    />
                                </div>
                            </div>

                            <div style={{ marginTop: '10px' }}>
                                <TextField 
                                    required={true}
                                    id='address1'
                                    name='address1'
                                    label='Address 1'
                                    autoComplete='off'
                                    placeholder='Enter Your Address'
                                    sx={{ width: '100%'}}
                                />
                            </div>

                            <div style={{ marginTop: '10px' }}>
                                <TextField
                                    id='address2'
                                    name='address2'
                                    label='Address 2'
                                    autoComplete='off'
                                    placeholder='Apartment,Suite,etc'
                                    sx={{ width: '100%'}}
                                />
                            </div>

                            <div style={{ display:'flex',marginTop:10,justifyContent:'space-between' }}>
                                <div style={{ width: '48%' }}>
                                    <TextField 
                                        required={true}
                                        id='city'
                                        name='city'
                                        label='City'
                                        autoComplete='off'
                                        placeholder='Enter Your City'
                                        sx={{ width: '100%'}}
                                    />
                                </div>


                                <div style={{ width: '48%' }}>
                                    <TextField 
                                        type="number"
                                        required={true}
                                        id='pincode'
                                        name='pincode'
                                        label='Pincode'
                                        autoComplete='off'
                                        placeholder='Enter Your Pincode'
                                        maxLength={6}
                                        sx={{ width: '100%'}}
                                        value={pincode}
                                        onBlur={(e) => handleMinLengthPinCode(e)}
                                        onChange={handlePincodeChange}
                                    />

                                    <div
                                        className={Classes.PhoneErrorMsg}
                                        id='pinErrMsg'
                                    >
                                        <p>Please enter a valid 6 digit pincode</p>
                                    </div>
                                </div>
                            </div>

                            <div style={{ display:'flex',marginTop:10,justifyContent:'space-between' }}>
                                <div style={{ width: '48%' }}>
                                    <Autocomplete
                                        freeSolo
                                        disablePortal
                                        id="state"
                                        name='state'
                                        options={states}
                                        ListboxProps={{sx: { fontSize: 14 }}}
                                        sx={{ width: '100%' }}
                                        onChange={(event, newValue) => {setSelectedState(newValue.id)}}
                                        renderInput={(params) => <TextField {...params} label="States" required/>}
                                    />
                                </div>

                                <div style={{ width: '48%' }}>
                                    <TextField 
                                        type="number"
                                        required={true}
                                        id='phone'
                                        name='phone'
                                        label='Phone'
                                        autoComplete='off'
                                        placeholder='Enter Your Phone Number'
                                        maxLength={10}
                                        sx={{ width: '100%'}}
                                        value={number}
                                        onBlur={(e) => handleMinLengthNumber(e)}
                                        onChange={(e) => handleNumberChange(e)}
                                    />

                                    <div
                                        className={Classes.PhoneErrorMsg}
                                        id='phoneErrMsg'
                                    >
                                        <p>Please enter a valid 10 digit mobile number</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={Classes.DialogBtnBox} style={{bottom: "10%"}}>
                            <button 
                                type="button" 
                                className={Classes.UpdateSalesUserOfCustomer}
                                onClick={hideShippingPop}
                            >
                                CANCEL
                            </button>

                            <button 
                                id='addAddress' 
                                type="submit" 
                                className={Classes.UpdateSalesUserOfCustomer}
                            >
                                ADD
                            </button>
                        </div>

                    </form>

                    {loading ? <Spinner /> : null}
                </div>
            )}
        </Fragment>
    );
}


export default ShippingPopUp;